'use es6';

import { createSelector } from 'reselect';
import { gate } from 'hub-http/gates';
export const getAuth = state => state.auth;
export const getGates = state => state.auth.gates;
export const getIsPortalUngatedForSkipVisibilityChecker = createSelector([getGates], gates => !!gates && gates.includes(gate('AdvancedMenus:SkipVisibilityChecker')));